export const MIIStore = (set: any, get: any, store: any) => ({
    number: 123,
    increaseCounterNumber: () => set((state: any) => ({ number: state.number + 1 })),
    decreaseCounterNumber: () => set((state: any) => ({ number: state.number - 1 })),
});
